import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const UpdatePassword = () => {
  const [data, setData] = useState({
    memberId: "mono7d8sf",
    currentPassword: "123456",
    newPassword: "",
    confirmNewPassword: "",
  });
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  // form show hide
  const [formToggle, setFormToggle] = useState(true);
  return (
    <div className="mono_updatepassword_page_wrapper">
      {formToggle && (
        <CardLayout
          style={{ backgroundColor: "#fff" }}
          className="mono_accountpassword_card"
        >
          <div className="mono_accountpassword_title">
            <h2>account password</h2>
          </div>
          <div className="mono_accountpassword_field">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  label="Member ID"
                  type="text"
                  value={data.memberId}
                  name="memberId"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="Current Password"
                  type="password"
                  value={data.currentPassword}
                  name="currentPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="New Password"
                  type="password"
                  value={data.newPassword}
                  name="newPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="Confirm New Password"
                  type="password"
                  value={data.confirmNewPassword}
                  name="confirmNewPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form-check form-check-label show_password" style={{display: "flex", alignItems: "center"}}>
                <Input
                  type="checkbox"
                  className="form-check-input form-check-label"
                  value="showpassword"
                  id="showpassword"
                  onChange={handleChange}
                />
                <label htmlFor="showpassword" className="form-check-label">
                  show Password
                </label>
              </div>
              <div className="form_group">
                <Button type="submit">update account password</Button>
              </div>
              <div className="form_group" style={{textAlign: "center"}}>
                <span>
                  Update TXN Password{" "}
                  <strong onClick={() => setFormToggle(false)}>
                    Click Here
                  </strong>
                </span>
              </div>
            </form>
          </div>
        </CardLayout>
      )}
      {!formToggle && (
        <CardLayout
          style={{ backgroundColor: "#fff" }}
          className="mono_txnpassword_card"
        >
          <div className="mono_txnpassword_title">
            <h2>txn password</h2>
          </div>
          <div className="mono_txnpassword_field">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  label="Member ID"
                  type="text"
                  value={data.memberId}
                  name="memberId"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="Current Password"
                  type="password"
                  value={data.currentPassword}
                  name="currentPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="New Password"
                  type="password"
                  value={data.newPassword}
                  name="newPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form_group">
                <Input
                  label="Confirm New Password"
                  type="password"
                  value={data.confirmNewPassword}
                  name="confirmNewPassword"
                  onChange={handleChange}
                />
              </div>
              <div className="form-check form-check-label show_password" style={{display: "flex", alignItems: "center"}}>
                <Input
                  type="checkbox"
                  className="form-check-input form-check-label"
                  value="showpassword"
                  id="showpassword"
                  onChange={handleChange}
                />
                <label htmlFor="showpassword" className="form-check-label">
                  show Password
                </label>
              </div>
              <div className="form_group">
                <Button type="submit">update txn password</Button>
              </div>
              <div className="form_group" style={{textAlign: "center"}}>
                <span>
                  Update Account Password{" "}
                  <strong onClick={() => setFormToggle(true)}>
                    Click Here
                  </strong>
                </span>
              </div>
            </form>
          </div>
        </CardLayout>
      )}
    </div>
  );
};

export default UpdatePassword;
